import { CartAddEvent } from '@theme/events';

const UPSELL_LOG_PREFIX = '[cart-upsell]';
const CART_REQUEST_TIMEOUT_MS = 5000;
const CART_RETRY_TIMEOUT_MS = 12000;
const CART_RETRY_DELAY_MS = 250;
const RECOMMENDATION_REQUEST_TIMEOUT_MS = 15000;
console.log(123123);
function ensureStyles() {
  if (document.getElementById('cart-drawer-upsell-styles')) return;

  const style = document.createElement('style');
  style.id = 'cart-drawer-upsell-styles';
  style.textContent = `
    .cart-drawer-upsell{display:flex;flex-direction:column;gap:10px}
    .cart-drawer-upsell__header{display:grid;grid-template-columns:34px 1fr 34px;align-items:center;gap:10px;margin-top:10px}
    .cart-drawer-upsell__title{text-align:center}
    .cart-drawer-upsell__arrow{width:34px;height:34px;border-radius:999px;border:1px solid rgb(var(--color-foreground-rgb,0 0 0)/.15);display:flex;align-items:center;justify-content:center}
    .cart-drawer-upsell__arrow--prev .svg-wrapper{transform:rotate(90deg)}
    .cart-drawer-upsell__arrow--next .svg-wrapper{transform:rotate(-90deg)}
    .cart-drawer-upsell__track{display:flex;gap:10px;overflow:auto;padding-bottom:4px;scrollbar-width:none;-ms-overflow-style:none}
    .cart-drawer-upsell__track::-webkit-scrollbar{display:none}
    .cart-drawer-upsell__item{flex:0 0 220px;display:grid;grid-template-columns:72px 1fr;gap:10px;border:1px solid rgb(var(--color-foreground-rgb,0 0 0)/.08);border-radius:12px;padding:10px;background:rgb(var(--color-background-rgb,255 255 255))}
    .cart-drawer-upsell__media{display:block;width:72px;height:72px;border-radius:10px;overflow:hidden;background:rgb(var(--color-foreground-rgb,0 0 0)/.04)}
    .cart-drawer-upsell__media img{width:100%;height:100%;object-fit:cover}
    .cart-drawer-upsell__meta{display:flex;flex-direction:column;gap:6px;min-width:0}
    .cart-drawer-upsell__name{font-size:13px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:inherit;text-decoration:none}
    .cart-drawer-upsell__price{font-size:13px;opacity:.85}
    .cart-drawer-upsell__add{padding:8px 10px;font-size:13px}
    .cart-drawer-upsell__empty{font-size:13px;opacity:.7;padding:6px 0}
    .cart-drawer-upsell__loading{font-size:13px;opacity:.7;padding:6px 0}
  `;
  document.head.appendChild(style);
}

/**
 * @param {HTMLElement} container
 */
function initOne(container) {
  const isFirstInit = container.dataset.upsellInit !== 'true';
  container.dataset.upsellInit = 'true';
  console.log(`${UPSELL_LOG_PREFIX} initOne start`, {
    isFirstInit,
    existingInitFlag: container.dataset.upsellInit,
    limit: container.dataset.upsellLimit,
    deliveryFeeHandle: container.dataset.deliveryFeeHandle,
    cartCurrency: container.dataset.cartCurrency,
  });

  try {
    ensureStyles();

    const track = container.querySelector('[data-upsell-track]');
    if (!(track instanceof HTMLElement)) return;

    const limit = Number(container.dataset.upsellLimit || 10);
    const deliveryFeeHandle = String(container.dataset.deliveryFeeHandle || '').toLowerCase();
    const currencyCode = String(container.dataset.cartCurrency || '').trim().toUpperCase();

    let moneyFormatter = null;
    if (/^[A-Z]{3}$/.test(currencyCode) && typeof Intl !== 'undefined') {
      moneyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode });
    }

    /**
     * @param {string} url
     * @param {number} timeoutMs
     * @returns {Promise<Response>}
     */
    const fetchWithTimeout = async (url, timeoutMs) => {
      console.log(`${UPSELL_LOG_PREFIX} fetch start`, url);
      const controller = new AbortController();
      const timeoutId = globalThis.setTimeout(() => controller.abort(), timeoutMs);

      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: controller.signal,
        });
        console.log(`${UPSELL_LOG_PREFIX} fetch done`, url, response.status);
        return response;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
          console.warn(`${UPSELL_LOG_PREFIX} fetch timeout`, { url, timeoutMs });
        } else {
          console.error(`${UPSELL_LOG_PREFIX} fetch failed`, url, error);
        }
        throw error;
      } finally {
        globalThis.clearTimeout(timeoutId);
      }
    };

    /**
     * @returns {Promise<any>}
     */
    const fetchCartJson = async () => {
      try {
        const cartRes = await fetchWithTimeout('/cart.js', CART_REQUEST_TIMEOUT_MS);
        if (!cartRes.ok) return {};
        return await cartRes.json().catch(() => ({}));
      } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'AbortError') throw error;

        console.warn(`${UPSELL_LOG_PREFIX} retry cart fetch after timeout`);
        await new Promise((resolve) => globalThis.setTimeout(resolve, CART_RETRY_DELAY_MS));

        const retryRes = await fetchWithTimeout('/cart.js', CART_RETRY_TIMEOUT_MS);
        if (!retryRes.ok) return {};
        return await retryRes.json().catch(() => ({}));
      }
    };

    /**
     * @returns {{ id: number, handle: string }[]}
     */
    const getCartProductsFromMarkup = () => {
      const jsonNode = container.querySelector('[data-upsell-cart-products]');
      if (!(jsonNode instanceof HTMLScriptElement)) return [];

      try {
        const parsed = JSON.parse(jsonNode.textContent || '[]');
        if (!Array.isArray(parsed)) return [];

        return parsed
          .map((item) => ({
            id: Number(item?.id || 0),
            handle: String(item?.handle || '').toLowerCase(),
          }))
          .filter((item) => item.id > 0);
      } catch (error) {
        console.warn(`${UPSELL_LOG_PREFIX} failed to parse upsell cart products`, error);
        return [];
      }
    };

    /**
     * @param {number} cents
     * @returns {string}
     */
    const formatPrice = (cents) => {
      if (moneyFormatter && Number.isFinite(cents)) {
        return moneyFormatter.format(cents / 100);
      }
      const shopifyApi = /** @type {{ formatMoney?: (amount: number) => string } | undefined} */ (
        /** @type {any} */ (globalThis).Shopify
      );
      if (shopifyApi && typeof shopifyApi.formatMoney === 'function') {
        return shopifyApi.formatMoney(cents);
      }
      return `${(Number(cents || 0) / 100).toFixed(2)}`;
    };

    /**
     * @param {string} text
     * @returns {string}
     */
    const escapeHtml = (text) =>
      String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    /**
     * @param {any} product
     * @returns {string}
     */
    const renderUpsellCard = (product) => {
      const variantId = Number(product?.variants?.[0]?.id || 0);
      if (!variantId) return '';
      const url = String(product?.url || '#');
      const title = escapeHtml(product?.title || '');
      const image = typeof product?.featured_image === 'string' ? product.featured_image : String(product?.featured_image?.url || '');
      const imageAlt = title;
      const price = Number(product?.price || 0);

      return `
      <div class="cart-drawer-upsell__item">
        <a class="cart-drawer-upsell__media" href="${url}">
          ${image ? `<img loading="lazy" src="${image}" alt="${imageAlt}" width="72" height="72">` : ''}
        </a>
        <div class="cart-drawer-upsell__meta">
          <a class="cart-drawer-upsell__name" href="${url}">${title}</a>
          <div class="cart-drawer-upsell__price">${escapeHtml(formatPrice(price))}</div>
          <button
            type="button"
            class="button button--secondary cart-drawer-upsell__add"
            data-upsell-add
            data-variant-id="${variantId}"
          >
            Add
          </button>
        </div>
      </div>
    `;
    };

    /**
     * @param {number} sourceProductId
     * @param {'complementary'|'related'} intent
     * @returns {Promise<any[]>}
     */
    const fetchRecommendationGroup = async (sourceProductId, intent) => {
      console.log(`${UPSELL_LOG_PREFIX} recommendation request`, { sourceProductId, intent, limit });
      const recRes = await fetchWithTimeout(
        `/recommendations/products.json?product_id=${sourceProductId}&limit=${limit}&intent=${intent}`,
        RECOMMENDATION_REQUEST_TIMEOUT_MS
      );
      if (!recRes.ok) return [];

      const recJson = await recRes.json().catch(() => ({}));
      const products = Array.isArray(recJson?.products) ? recJson.products : [];
      console.log(`${UPSELL_LOG_PREFIX} recommendation response`, {
        sourceProductId,
        intent,
        count: products.length,
      });
      return products;
    };

    /**
     * @returns {Promise<any[]>}
     */
    const loadRecommendations = async () => {
      console.log(`${UPSELL_LOG_PREFIX} loadRecommendations start`);
      let items = getCartProductsFromMarkup();
      let cartSource = 'markup';

      if (!items.length) {
        const cart = await fetchCartJson();
        items = Array.isArray(cart?.items)
          ? cart.items.map((/** @type {any} */ item) => ({
              id: Number(item?.product_id || 0),
              handle: String(item?.handle || '').toLowerCase(),
            }))
          : [];
        cartSource = 'api';
      }

      console.log(`${UPSELL_LOG_PREFIX} cart loaded`, {
        source: cartSource,
        itemCount: items.length,
        productIds: items.map((/** @type {{ id?: number }} */ item) => item?.id).filter(Boolean),
      });
      if (!items.length) return [];

      const cartProductIds = new Set(items.map((/** @type {{ id?: number }} */ item) => Number(item?.id || 0)).filter(Boolean));
      const cartProductHandles = new Set(
        items.map((/** @type {{ handle?: string }} */ item) => String(item?.handle || '').toLowerCase()).filter(Boolean)
      );

      const sourceProductIds = items
        .filter((/** @type {{ handle?: string }} */ item) => String(item?.handle || '').toLowerCase() !== deliveryFeeHandle)
        .map((/** @type {{ id?: number }} */ item) => Number(item?.id || 0))
        .filter((productId, index, arr) => productId > 0 && arr.indexOf(productId) === index)
        .slice(0, 5);
      const seenProducts = new Set();
      /** @type {any[]} */
      const recommendations = [];

      /**
       * @param {any[]} products
       * @returns {number}
       */
      const appendEligibleProducts = (products) => {
        let addedCount = 0;
        for (const product of products) {
          if (recommendations.length >= limit) break;

          const productId = Number(product?.id || 0);
          const productHandle = String(product?.handle || '').toLowerCase();
          const firstVariant = product?.variants?.find((/** @type {any} */ variant) => variant?.available) || product?.variants?.[0];

          if (!productId || !firstVariant?.available) continue;
          if (cartProductIds.has(productId)) continue;
          if (deliveryFeeHandle && productHandle === deliveryFeeHandle) continue;
          if (cartProductHandles.has(productHandle)) continue;
          if (seenProducts.has(productId)) continue;

          seenProducts.add(productId);
          recommendations.push({
            ...product,
            variants: [firstVariant],
          });
          addedCount += 1;
        }
        return addedCount;
      };

      for (const sourceProductId of sourceProductIds) {
        if (recommendations.length >= limit) break;

        let complementaryProducts = [];
        let complementaryFailed = false;
        try {
          complementaryProducts = await fetchRecommendationGroup(sourceProductId, 'complementary');
        } catch (error) {
          complementaryFailed = true;
          console.warn(`${UPSELL_LOG_PREFIX} complementary failed`, { sourceProductId, error });
        }

        const complementaryAdded = appendEligibleProducts(complementaryProducts);
        if (complementaryAdded > 0 || recommendations.length >= limit) continue;

        try {
          const relatedProducts = await fetchRecommendationGroup(sourceProductId, 'related');
          appendEligibleProducts(relatedProducts);
        } catch (error) {
          console.warn(`${UPSELL_LOG_PREFIX} related failed`, {
            sourceProductId,
            complementaryFailed,
            error,
          });
        }
      }

      console.log(`${UPSELL_LOG_PREFIX} loadRecommendations done`, {
        total: recommendations.length,
        ids: recommendations.map((product) => product?.id).filter(Boolean),
      });
      return recommendations;
    };

    const showEmptyState = () => {
      const liveTrack = container.querySelector('[data-upsell-track]');
      const liveEmpty = container.querySelector('[data-upsell-empty]');
      if (!(liveTrack instanceof HTMLElement)) return;
      liveTrack.innerHTML = '';
      if (liveEmpty instanceof HTMLElement) {
        liveEmpty.hidden = false;
        liveTrack.appendChild(liveEmpty);
      }
    };

    const renderRecommendations = async () => {
      if (container.dataset.upsellRenderInFlight === 'true') {
        console.log(`${UPSELL_LOG_PREFIX} renderRecommendations skipped (in-flight)`);
        return;
      }
      container.dataset.upsellRenderInFlight = 'true';
      const liveTrack = container.querySelector('[data-upsell-track]');
      if (!(liveTrack instanceof HTMLElement)) {
        container.dataset.upsellRenderInFlight = 'false';
        return;
      }
      console.log(`${UPSELL_LOG_PREFIX} renderRecommendations start`);
      const liveLoading = container.querySelector('[data-upsell-loading]');
      const liveEmpty = container.querySelector('[data-upsell-empty]');
      if (liveLoading instanceof HTMLElement) liveLoading.hidden = false;
      if (liveEmpty instanceof HTMLElement) liveEmpty.hidden = true;

      try {
        const products = await loadRecommendations();
        const cards = products.map(renderUpsellCard).filter(Boolean);
        if (!cards.length) {
          console.log(`${UPSELL_LOG_PREFIX} no cards after filtering`);
          showEmptyState();
          return;
        }

        const currentTrack = container.querySelector('[data-upsell-track]');
        if (!(currentTrack instanceof HTMLElement)) return;
        currentTrack.innerHTML = cards.join('');
        console.log(`${UPSELL_LOG_PREFIX} rendered cards`, cards.length);
      } catch (error) {
        console.error('Failed to load cart drawer recommendations:', error);
        showEmptyState();
      } finally {
        container.dataset.upsellRenderInFlight = 'false';
        container.querySelectorAll('[data-upsell-loading]').forEach((node) => node.remove());
        console.log(`${UPSELL_LOG_PREFIX} renderRecommendations end`);
      }
    };

    void renderRecommendations();

    /** @param {number} dir */
    const scrollBy = (dir) => {
      track.scrollBy({ left: dir * 260, behavior: 'smooth' });
    };

    if (container.dataset.upsellEventsBound !== 'true') {
      container.dataset.upsellEventsBound = 'true';
      container.addEventListener('click', async (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        if (target.closest('[data-upsell-prev]')) {
          scrollBy(-1);
          return;
        }

        if (target.closest('[data-upsell-next]')) {
          scrollBy(1);
          return;
        }

        const btn = target.closest('[data-upsell-add]');
        if (!(btn instanceof HTMLButtonElement)) return;

        const variantId = Number(btn.dataset.variantId || 0);
        if (!variantId) return;

        btn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
          if (!res.ok) return;

          const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
          const cart = cartRes.ok ? await cartRes.json().catch(() => ({})) : {};

          document.dispatchEvent(
            new CartAddEvent(cart, 'cart-drawer-upsell', {
              source: 'cart-drawer-upsell',
              itemCount: Number(cart?.item_count || 0),
            })
          );
        } finally {
          btn.disabled = false;
        }
      });
    }
  } catch (error) {
    console.error('Failed to initialize cart drawer upsell:', error);
    const loading = container.querySelector('[data-upsell-loading]');
    const empty = container.querySelector('[data-upsell-empty]');
    if (loading instanceof HTMLElement) loading.remove();
    if (empty instanceof HTMLElement) empty.hidden = false;
  }
}

export function initCartDrawerUpsell() {
  const containers = document.querySelectorAll('[data-cart-drawer-upsell]');
  console.log(`${UPSELL_LOG_PREFIX} initCartDrawerUpsell`, { containers: containers.length });
  containers.forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    console.log(`${UPSELL_LOG_PREFIX} container found`, {
      upsellInit: el.dataset.upsellInit,
      upsellEventsBound: el.dataset.upsellEventsBound,
    });
    initOne(el);
  });
}

let initQueued = false;

function scheduleUpsellInit() {
  if (initQueued) return;
  initQueued = true;

  globalThis.requestAnimationFrame(() => {
    initQueued = false;
    initCartDrawerUpsell();
  });
}

initCartDrawerUpsell();
document.addEventListener('cart:update', () => scheduleUpsellInit());
document.addEventListener('DOMContentLoaded', () => scheduleUpsellInit());

const upsellDomObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      const addedUpsellContainer =
        node.matches('[data-cart-drawer-upsell]') || node.querySelector('[data-cart-drawer-upsell]');
      const addedUpsellContent =
        node.matches('[data-upsell-track], [data-upsell-loading], [data-upsell-empty]') ||
        node.querySelector('[data-upsell-track], [data-upsell-loading], [data-upsell-empty]');
      const parentUpsellContainer = node.closest('[data-cart-drawer-upsell]');

      if (addedUpsellContainer || (addedUpsellContent && parentUpsellContainer)) {
        console.log(`${UPSELL_LOG_PREFIX} mutation detected new upsell container`);
        scheduleUpsellInit();
        return;
      }
    }
  }
});

if (document.body) {
  console.log(123213);
  upsellDomObserver.observe(document.body, { childList: true, subtree: true });
}
